import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const carouselSections = document.querySelectorAll('.magazines-carousel');

  if (0 < carouselSections.length) {
    carouselSections.forEach((carouselSection) => {
      const fraction = carouselSection.querySelector('.fraction');
      const swiper = new Swiper(
        carouselSection.querySelector('.magazines-carousel__carousel'),
        {
          spaceBetween: 12,
          slidesPerView: 1.3,
          watchOverflow: true,
          keyboard: true,
          init: false,

          pagination: {
            el: carouselSection.querySelector('.swiper-pagination'),
            type: 'progressbar',
          },

          navigation: {
            prevEl: carouselSection.querySelector('.swiper-button-prev'),
            nextEl: carouselSection.querySelector('.swiper-button-next'),
          },

          breakpoints: {
            600: {
              slidesPerView: 1.6,
              spaceBetween: 16,
            },
            860: {
              slidesPerView: 2.6,
              spaceBetween: 16,
            },
            1020: {
              slidesPerView: 3.4,
              spaceBetween: 32,
            },
            1400: {
              slidesPerView: 'auto',
              spaceBetween: 32,
            },
          },

          a11y: {
            firstSlideMessage: _x(
              'This is the first slide',
              'swiper label',
              'vtx'
            ),
            lastSlideMessage: _x(
              'This is the last slide',
              'swiper label',
              'vtx'
            ),
            prevSlideMessage: _x('Go to previous slide', 'swiper label', 'vtx'),
            nextSlideMessage: _x('Go to next slide', 'swiper label', 'vtx'),
            slideLabelMessage: _x(
              'Slide {{index}} of {{slidesLength}}',
              'swiper label',
              'vtx'
            ),
            paginationBulletMessage: _x(
              'Go to slide {{index}}',
              'swiper label',
              'vtx'
            ),
          },
        }
      );

      swiper.on('init', () => {
        const slideNumber = swiper.realIndex + 1;
        fraction.querySelector('.current').textContent = slideNumber;
        fraction.querySelector('.total').textContent = swiper.slides.length;
      });

      swiper.on('slideChange', () => {
        const slideNumber = swiper.realIndex + 1;
        fraction.querySelector('.current').textContent = slideNumber;
      });

      swiper.init();
    });
  }
});
